import { Popover } from "@mui/material";
import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";
import { fontWeightBold, h3Regular } from "../typography/MuiTypography.style";

export const StyledPopover = styled(Popover)<{ popoverWidth?: number }>`
  .MuiPaper-root {
    padding: 4px;
    border-radius: 4px;
    margin-top: 8px;
    /* width: ${(props) => props.popoverWidth}px; */
    width: auto;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.25);
  }

  .MuiInputBase-adornedStart {
    background: ${COLORS.cirrus_black1};
  }

  .MuiInputAdornment-root {
    margin: 0;
    color: ${COLORS.primary_light_blue};
  }

  .MuiFormHelperText-root {
    margin-top: 8px;
    font-size: 14px;
    line-height: 14px;
    font-weight: 600;
    color: ${COLORS.cirrus_red};
  }

  .empty-item {
    min-width: 325px;
  }

  .options-list {
    max-height: 240px;
    overflow-y: auto;

    /* Custom scrollbar styles */
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: ${COLORS.cirrus_black1};
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${COLORS.cirrus_scrollbar_thumb};
      border-radius: 8px;
    }

    /* Hide scrollbar arrows */
    &::-webkit-scrollbar-button {
      display: none;
    }

    /* Custom scrollbar styles for Firefox */
    @-moz-document url-prefix() {
      scrollbar-width: thin;
      scrollbar-color: ${COLORS.cirrus_scrollbar_thumb} ${COLORS.cirrus_black1};
    }
  }

  .option-item {
    height: 48px;
    padding: 15px 15px 15px 13px;
    cursor: pointer;

    .MuiListItemText-root {
      margin: 0.5px 0;
      .MuiTypography-root {
        ${h3Regular}
        height: 19px;
        line-height: 19.36px;
        color: ${COLORS.cirrus_black};
      }
    }

    &:focus-visible {
      outline: none;
      background-color: rgba(0, 0, 0, 0.12);
      border-radius: 8px;
    }

    &.header-option-item {
      border-bottom: 1px solid ${COLORS.cirrus_black3};
      border-radius: 8px;
    }
  }

  .country-option-item {
    height: 48px;
    padding: 15px 15px 15px 20px;
    cursor: pointer;

    .MuiListItemText-root {
      margin: 0.5px 0;
      display: flex;
      margin-left: 8px;
      margin-right: 8px;
      .MuiTypography-body1 {
        ${h3Regular}
        ${fontWeightBold}
        line-height: 19.36px;
        height: 19px;
        color: ${COLORS.cirrus_black};
      }
      .MuiTypography-body2 {
        ${h3Regular}
        line-height: 19.36px;
        margin-left: 8px;
      }
    }

    .country-flag {
      height: 24px;
      width: 24px;
    }
  }
  .error-icon {
    word-break: break-word;
  }

  .MuiCheckbox-root {
    padding: 0;
    margin-right: 8px;
    color: ${COLORS.primary_light_blue};
    .MuiSvgIcon-root {
      height: 18px;
      width: 18px;
      border: 2px;
    }
  }

  .done-button-container {
    padding: 4px;
    .MuiButton-root {
      width: 100%;
      height: 48px;
    }
  }

  .double-label {
    align-items: flex-start;
    .MuiCheckbox-root .MuiSvgIcon-root {
      height: 20px;
      width: 20px;
    }
    .checkbox-with-double-label {
      margin: -1px 0px !important;

      .MuiTypography-body1 {
        font-weight: 600 !important;
      }
      .MuiTypography-body2 {
        text-transform: capitalize;
        margin-top: 3px;
      }
    }
  }

  .empty-message {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 325px;
    color: ${COLORS.cirrus_black};
  }
`;
